import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }


  /**
   * Decrypt encrypted data using AES-GCM with the given password.
   */
  async decrypt(encryptedData: string, password: string) {
    try {
      const key = await this.getKey(password);
      const bytes = Uint8Array.from(atob(encryptedData), (c) => c.charCodeAt(0));
      const iv = bytes.slice(0, 12), data = bytes.slice(12);
      const decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, data);
      return JSON.parse(new TextDecoder().decode(decrypted));
    } catch (error) {
      console.log('Error decrypting:', error);
    }
  }

  /**
   * Generate AES-GCM compatible CryptoKey from a password using SHA-256.
   */
  async getKey(password: string) {
    const encoder = new TextEncoder();
    const encoded = encoder.encode(password);
    const hashed = await crypto.subtle.digest('SHA-256', encoded);

    return crypto.subtle.importKey(
      'raw',
      hashed,
      { name: 'AES-GCM' },
      false,
      ['encrypt', 'decrypt'],
    );
  }
}
